import { Button } from "antd";
import { FC, useMemo } from "react";
import classNames from "classnames";

import styles from "./index.less";

import BasicIcon from "../../assets/icons/basic.svg";
import PlusIcon from "../../assets/icons/plus.svg";
import ProIcon from "../../assets/icons/pro.svg";
import UltraIcon from "../../assets/icons/ultra.svg";

import BasicExpiredStamp from "../../assets/stamps/basic.svg";
import PlusExpiredStamp from "../../assets/stamps/plus.svg";
import ProExpiredStamp from "../../assets/stamps/pro.svg";
import UltraExpiredStamp from "../../assets/stamps/ultra.svg";

import { PricingPlanVersionEnum } from "../../types";

interface PlanExpiredProps {
  expiredVersion: PricingPlanVersionEnum;
  expiredDate: string;
  onRenew: () => void;
}

const PlanExpired: FC<PlanExpiredProps> = ({
  expiredVersion,
  expiredDate,
  onRenew,
}) => {
  const expiredVersionMap = useMemo(() => {
    switch (expiredVersion) {
      case PricingPlanVersionEnum.BASIC:
        return { name: "Basic", icon: BasicIcon, stamp: BasicExpiredStamp };
      case PricingPlanVersionEnum.PLUS:
        return { name: "Plus", icon: PlusIcon, stamp: PlusExpiredStamp };
      case PricingPlanVersionEnum.PRO:
        return { name: "Pro", icon: ProIcon, stamp: ProExpiredStamp };
      case PricingPlanVersionEnum.ULTRA:
        return { name: "Ultra", icon: UltraIcon, stamp: UltraExpiredStamp };
    }
  }, [expiredVersion]);

  return (
    <div className={styles["plan-expired"]}>
      <div className={styles["header"]}>
        <div
          className={classNames(styles["expired-version"], {
            [styles["expired-version-basic"]]:
              expiredVersion === PricingPlanVersionEnum.BASIC,
            [styles["expired-version-plus"]]:
              expiredVersion === PricingPlanVersionEnum.PLUS,
            [styles["expired-version-pro"]]:
              expiredVersion === PricingPlanVersionEnum.PRO,
            [styles["expired-version-ultra"]]:
              expiredVersion === PricingPlanVersionEnum.ULTRA,
          })}
        >
          <div
            className={classNames(styles["version"], {
              [styles["version-basic"]]:
                expiredVersion === PricingPlanVersionEnum.BASIC,
              [styles["version-plus"]]:
                expiredVersion === PricingPlanVersionEnum.PLUS,
              [styles["version-pro"]]:
                expiredVersion === PricingPlanVersionEnum.PRO,
              [styles["version-ultra"]]:
                expiredVersion === PricingPlanVersionEnum.ULTRA,
            })}
          >
            <img
              className={styles["icon"]}
              src={expiredVersionMap.icon}
              alt={expiredVersionMap.name}
            />
            <span>{expiredVersionMap.name}</span>
          </div>

          <div className={styles["stamp"]}>
            <img src={expiredVersionMap.stamp} alt="expired" />
          </div>
        </div>
      </div>
      <div className={styles["content"]}>
        <div className={styles["title"]}>
          当前订阅的{expiredVersionMap.name}版已过期
        </div>
        <div className={styles["description"]}>
          您订阅的 12Times · {expiredVersionMap.name}版服务于&nbsp;{expiredDate}
          &nbsp;到期，逾期未续费将影响您的正常使用
        </div>
        <Button type="primary" className={styles["btn"]} onClick={onRenew}>
          立即续费
        </Button>
      </div>
    </div>
  );
};

export default PlanExpired;
